import api from '../api';

export const getListItem = async () => {
    const result = await api.get('/admin/item');
    return result.data.data;
}

export const getListItemByTitle = async (title) => {
    const result = await api.get(`/admin/${title}/item`);
    return result.data;
}

export const getOneItem = async (id) => {
    const result = await api.get(`/admin/item/${id}`);
    return result.data.data;
}

export const createItem = async (data) => {
    try {
        const response = await api.post('/admin/item', data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const deleteItem = async (id) => {
    try {
        const response = await api.delete(`/admin/item/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateItem = async (data, id, lang) => {
    try {
        const response = await api.post(`/admin/item/${id}`, data, {
            headers: {
                "Accept-Language": lang
            }
        });
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusItem = async (id) => {
    try {
        const response = await api.put(`/admin/item/${id}/status`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}



